<template>
  <div class="col-12 quick-v-attr-select">
    <span class="attr-title">
          {{ similarGroup.similarGroupName }}
        </span>
    <div class="attr-prop">
      <div class="attr-select-in" v-show="getSelectedText.length > 0">
        {{ getSelectedText }}
      </div>
      <button
        v-for="similarEntry in getSimilarEntriesOfThisGroupFromSimilarGroupData"
        :key="similarEntry.similarId"
        class="attr-btn-color"
        v-on:click="navigateToProduct(similarEntry.similarId)"
        :style="'background:'+ similarEntry.similarDisplayValue">
        <span><i :class="defaultValue === similarEntry.similarName ? 'lni lni-checkmark' : 'lni'"></i></span>
      </button>
    </div>
  </div>

</template>

<script>
import similarSelectorMixin from '../mixins/similarSelectorMixin'

export default {
  name: 'SimilarHexSelector',
  mixins: [similarSelectorMixin],
  data () {
    return {
      version: '0.0.2'
    }
  }
}
</script>
